/* jscs:disable disallowFunctionDeclarations*/
(function(){
  'use strict';

  angular
    .module('AcaApp')
    .directive('ngBarTopData', NgBarTopData);

  NgBarTopData.$inject = [
    '$window',
    'UtilsService',
    '$interval',
    '$timeout'
  ];

  /* jscs:disable disallowFunctionDeclarations*/
  function NgBarTopData($window, utilService, $interval, $timeout){
    var dir = {
      templateUrl: 'app/views/common/directives/bar/bar-top.html',
      controller: Controller,
      controllerAs: 'barCtrl',
      bindToController: true,
      scope: {
        email: '=',
        cid: '=',
        customer: '=',
        datetime: '='
      }
    };

    return dir;

    function Controller(){
      var _this = this;

      _this.email = '';
      _this.cid = '';
      _this.customer = '';
      _this.datetime = '';
      _activate();

      /** @private */
      function _activate(){
        _this.email = $window.sessionStorage.userName;
        $interval(_setTime, 500);
        $timeout(_setDataCustomer, 500);
      }

      /** @private */
      function _setDataCustomer(){
        _this.cid = $window.sessionStorage.cid;
        _this.customer = $window.sessionStorage.customerName;
      }

      /** @private */
      function _setTime(){
        _this.datetime = utilService.getUnixTimestamp(Date.now());
      }
    }
  }
})();